import React, { useState } from 'react';
import './obituary.scss';

const Card = ({ imageSrc, color, title, description, link, linkText }) => {
    const [hover, setHover] = useState(false);

    return (
        <section className="obituary-card">
            <img src={imageSrc} alt="" />
            <div className="obituary-card-container">
                <h2 className="obituary-card-text">{title}</h2>
                {/* <p>{description}</p> */}
                <div className="obituary-link-container">
                    <a
                        className="viewlogies-button obituary-link"
                        href={link}
                        target="_blank"
                        rel="noopen noreferrer"
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        style={{
                            color: hover ? color : '#fff',
                            border: `2px solid ${color}`,
                            backgroundColor: hover ? 'unset' : color,
                        }}
                    >
                        {linkText}
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Card;
